import { useState } from "react";
import CryptoJS from "crypto-js";

const useEncryption = () => {
  const [encryptionKey] = useState(process.env.REACT_APP_SECRET_KEY);

  const encryptData = (data) => {
    try {
      const dataToEncrypt = JSON.stringify(data);
      const encryptedData = CryptoJS.AES.encrypt(
        dataToEncrypt,
        encryptionKey
      ).toString();
      return encryptedData;
    } catch (error) {
      console.error(error);
      return "";
    }
  };

  const decryptData = (data) => {
    try {
      if (!data) {
        return null;
      }
      const decryptedOutput = CryptoJS.AES.decrypt(
        data,
        encryptionKey
      ).toString(CryptoJS.enc.Utf8);
      try {
        const output = JSON.parse(decryptedOutput);
        return output;
      } catch (error) {
        return decryptedOutput;
      }
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  return { encryptData, decryptData };
};

export default useEncryption;
